import React from "react";

interface KpiCardProps {
  label: string;
  value: string | number;
  note?: string;
  dotColor?: "ok" | "bad" | "warn" | "blue" | "";
}

export function KpiCard({ label, value, note, dotColor = "" }: KpiCardProps) {
  return (
    <div className="kpi-card">
      <p className="kpi-label">{label}</p>
      <p className="kpi-value">{value}</p>
      {note ? (
        <p className="kpi-note">
          {dotColor ? <span className={`dot ${dotColor}`}></span> : null}
          {note}
        </p>
      ) : null}
    </div>
  );
}
